import type { Tag } from '@/modules/task/domain/tag/Tag';
import { TagType } from '@/modules/task/domain/tag/Tag';

export class VoiceMessageTag implements Tag {
  readonly type = TagType.VoiceMessage;

  readonly content = '';
}
